"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateSponsoredCompetitionBodyToJSON = exports.UpdateSponsoredCompetitionBodyFromJSONTyped = exports.UpdateSponsoredCompetitionBodyFromJSON = void 0;
var _1 = require("./");
function UpdateSponsoredCompetitionBodyFromJSON(json) {
    return UpdateSponsoredCompetitionBodyFromJSONTyped(json, false);
}
exports.UpdateSponsoredCompetitionBodyFromJSON = UpdateSponsoredCompetitionBodyFromJSON;
function UpdateSponsoredCompetitionBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'sponsorBrandName': json['sponsorBrandName'],
        'description': json['description'],
        'promotionImage': json['promotionImage'],
        'rewards': (json['rewards'].map(_1.CreateSponsoredRewardRequestFromJSON)),
        'runningMonth': json['runningMonth'],
        'runningYear': json['runningYear'],
        'brandUrl': json['brandUrl'],
    };
}
exports.UpdateSponsoredCompetitionBodyFromJSONTyped = UpdateSponsoredCompetitionBodyFromJSONTyped;
function UpdateSponsoredCompetitionBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'sponsorBrandName': value.sponsorBrandName,
        'description': value.description,
        'promotionImage': value.promotionImage,
        'rewards': (value.rewards.map(_1.CreateSponsoredRewardRequestToJSON)),
        'runningMonth': value.runningMonth,
        'runningYear': value.runningYear,
        'brandUrl': value.brandUrl,
    };
}
exports.UpdateSponsoredCompetitionBodyToJSON = UpdateSponsoredCompetitionBodyToJSON;
